module.exports = __webpack_public_path__ + "img/portfolio-5.b33dbc1f.jpg";